import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ValidationErrors as VueValidationErrors } from 'vue-validate-form';
import { UiError } from '@huntflow/ui';
export default /*@__PURE__*/ _defineComponent({
    __name: 'validation-errors',
    props: {
        name: {},
        all: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(VueValidationErrors), { name: __props.name }, {
                default: _withCtx(({ errors }) => [
                    (__props.all && errors.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(errors, (error, index) => {
                            return (_openBlock(), _createBlock(_unref(UiError), { key: index }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(error.message), 1)
                                ]),
                                _: 2
                            }, 1024));
                        }), 128))
                        : (errors.length)
                            ? (_openBlock(), _createBlock(_unref(UiError), { key: 1 }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(errors[0].message), 1)
                                ]),
                                _: 2
                            }, 1024))
                            : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["name"]));
        };
    }
});
